import { render, staticRenderFns } from "./car-serial-table.vue?vue&type=template&id=e2a9567e&"
import script from "./car-serial-table.vue?vue&type=script&lang=js&"
export * from "./car-serial-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports